// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"f73377cc","177":"f0d9794e","444":"e60e2f2c","533":"079f3bda","708":"cd177707","948":"3e26dc68"}[chunkId] + ".chunk.js";
};